<template>

 <v-app id="inspire" style="padding: 0px !important;border:0px !important">
    <div>
      <v-app-bar
      color="deep-purple accent-4"
      dense
      dark
    >
      <v-app-bar-nav-icon></v-app-bar-nav-icon>

      <v-toolbar-title>Aspire Installer</v-toolbar-title>

      <v-spacer></v-spacer>

      
        <v-btn to="/login" text>Logout</v-btn>
      

     

      <v-menu
        left
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="n in 5"
            :key="n"
            @click="() => {}"
          >
            <v-list-item-title>Option {{ n }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    </div>
    <v-content>
      <v-container fluid class="mt-12">
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>

</template>
<script>
   
    export default {
        name:"ProjectListLayout",
        data(){
            return {
                sideNav: false,
                menuItems: [
                   
                ]
            }
        },
        mounted() {
            console.log('App Component mounted.')
        },
      
    }
</script>


